import { Injectable, Optional } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AlyleServiceConfig } from './alyle-config-service';
var Color = (function () {
    function Color() {
    }
    return Color;
}());
export { Color };
function Color_tsickle_Closure_declarations() {
    /** @type {?} */
    Color.prototype.name;
    /** @type {?} */
    Color.prototype.color;
    /** @type {?} */
    Color.prototype.text;
}
/**
 * @param {?} color
 * @return {?}
 */
export function themeProperty(color) {
    if (color == 'primary' || color == 'accent' || color == 'other') {
        return true;
    }
    return false;
}
/**
 * @param {?} colors
 * @param {?} color
 * @return {?}
 */
export function getColor(colors, color) {
    if (themeProperty(color)) {
        // console.warn('colors', colors[color].color);
        return colors[color].color;
    }
    else {
        // console.warn('colors', color);
        return color;
    }
}
/**
 * @param {?} data
 * @return {?}
 */
export function findColor(data) {
    return LyPalette.colors.find(function (_) { return _.name === data; });
}
var LyTheme = (function () {
    /**
     * @param {?} config
     */
    function LyTheme(config) {
        if (config) {
            var primary = config.primary;
            var accent = config.accent;
            var other = config.other;
            var getAllColors = {
                primary: findColor(primary),
                accent: findColor(accent),
                other: findColor(other),
            };
            this.primary = new BehaviorSubject(findColor(primary));
            this.accent = new BehaviorSubject(findColor(accent));
            this.other = new BehaviorSubject(findColor(other));
            this.palette = new BehaviorSubject(getAllColors);
            /* tslint:disable */
            this.AlyleUI = {
                currentTheme: config,
                palette: getAllColors,
            };
            /* tslint:enable */
        }
    }
    /**
     * for bg or color inputs, find the color in palette, return color
     * example: this.theme.update('bg', 'primary', this.theme.AlyleUI.palette); // #00bcd4
     * @param {?} color
     * @param {?=} colors
     * @return {?}
     */
    LyTheme.prototype.color = function (color, colors) {
        var /** @type {?} */ result;
        if (colors) {
            result = getColor(colors, color);
        }
        else {
            result = getColor(this.AlyleUI.palette, color);
        }
        return result;
    };
    /**
     * Get palette from theme
     * @param {?} colorName
     * @return {?}
     */
    LyTheme.prototype.paletteOf = function (colorName) {
        return findColor(colorName);
    };
    return LyTheme;
}());
export { LyTheme };
// fontFamily: Subject<string> = new Subject<string>();
// sasdasd: Subject<Color> = new Subject<Color>();
LyTheme.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LyTheme.ctorParameters = function () { return [
    { type: AlyleServiceConfig, decorators: [{ type: Optional },] },
]; };
function LyTheme_tsickle_Closure_declarations() {
    /** @type {?} */
    LyTheme.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyTheme.ctorParameters;
    /** @type {?} */
    LyTheme.prototype.AlyleUI;
    /** @type {?} */
    LyTheme.prototype.primary;
    /** @type {?} */
    LyTheme.prototype.accent;
    /** @type {?} */
    LyTheme.prototype.other;
    /** @type {?} */
    LyTheme.prototype.palette;
}
var BgAndColorStyle = (function () {
    function BgAndColorStyle() {
    }
    return BgAndColorStyle;
}());
export { BgAndColorStyle };
function BgAndColorStyle_tsickle_Closure_declarations() {
    /** @type {?} */
    BgAndColorStyle.prototype.bg;
    /** @type {?} */
    BgAndColorStyle.prototype.color;
    /** @type {?} */
    BgAndColorStyle.prototype.theme;
    /** @type {?} */
    BgAndColorStyle.prototype.styleBackground;
    /** @type {?} */
    BgAndColorStyle.prototype.styleColor;
}
var LyStyleTheme = (function () {
    /**
     * @param {?} theme
     */
    function LyStyleTheme(theme) {
        this.theme = theme;
    }
    /**
     * for bg or color inputs, find the color in palette, return color
     * example: this.theme.update('bg', 'primary', this.theme.AlyleUI.palette); // #00bcd4
     * @param {?} color
     * @param {?=} colors
     * @return {?}
     */
    LyStyleTheme.prototype.getPalette = function (color, colors) {
        var /** @type {?} */ result;
        if (colors) {
            result = getColor(colors, color);
        }
        else {
            result = getColor(this.theme.AlyleUI.palette, color);
        }
        return result;
    };
    return LyStyleTheme;
}());
export { LyStyleTheme };
LyStyleTheme.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LyStyleTheme.ctorParameters = function () { return [
    { type: LyTheme, },
]; };
function LyStyleTheme_tsickle_Closure_declarations() {
    /** @type {?} */
    LyStyleTheme.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyStyleTheme.ctorParameters;
    /** @type {?} */
    LyStyleTheme.prototype.theme;
}
var LyPalette = (function () {
    /**
     * @param {?} lyTheme
     */
    function LyPalette(lyTheme) {
        this.lyTheme = lyTheme;
        this._primary = {
            name: 'none',
            color: '#fff',
            text: '#fff',
        };
        this._accent = {
            name: 'none',
            color: '#fff',
            text: '#fff',
        };
        this._other = {
            name: 'none',
            color: '#fff',
            text: '#fff',
        };
        this.themeApp = {
            light: {
                color: '#24292e',
                background: '#f5f5f5',
            },
            dark: {
                color: '#f5f5f5',
                background: '#2C2D31',
            },
        };
        this.text = {
            default: 'rgba(0, 0, 0, 0.75)',
            light: '#fff',
            dark: '#2C2D31',
        };
    }
    /**
     * Set a new color
     * @param {?} name
     * @param {?} color
     * @return {?}
     */
    LyPalette.setNewColor = function (name, color) {
        LyPalette.colors.push({
            name: name,
            color: color
        });
    };
    /**
     * Set a theme
     * @param {?=} primary
     * @param {?=} accent
     * @param {?=} other
     * @return {?}
     */
    LyPalette.prototype.setTheme = function (primary, accent, other) {
        if (primary) {
            var /** @type {?} */ color = this.setPrimary(primary);
        }
        if (accent) {
            var /** @type {?} */ color = this.setAccent(accent);
        }
        if (other) {
            var /** @type {?} */ color = this.setOther(other);
        }
    };
    Object.defineProperty(LyPalette.prototype, "theme", {
        /**
         * Get Theme App
         * @return {?}
         */
        get: function () {
            return this.text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyPalette.prototype, "primary", {
        /**
         * @return {?}
         */
        get: function () {
            return this._primary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyPalette.prototype, "accent", {
        /**
         * @return {?}
         */
        get: function () {
            return this._accent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyPalette.prototype, "other", {
        /**
         * @return {?}
         */
        get: function () {
            return this._other;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    LyPalette.prototype._ver = function () {
        if (this._style) {
            document.body.removeChild(this._style);
        }
    };
    /**
     * @return {?}
     */
    LyPalette.prototype.destroyTheme = function () {
        document.body.removeChild(this._style);
    };
    /**
     * @return {?}
     */
    LyPalette.prototype.updateTheme = function () {
        this._ver();
        var /** @type {?} */ style = document.createElement('style');
        style.innerHTML = "\n@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700');\n.ly-primary-color {\n  color: " + this.primary.color + "\n}\n.ly-primary-bg {\n  background: " + this.primary.color + "\n}\n.ly-accent-color {\n  color: " + this.accent.color + "\n}\n.ly-accent-bg {\n  background: " + this.accent.color + "\n}\n.ly-other-color {\n  color: " + this.other.color + "\n}\n.ly-other-bg {\n  background: " + this.other.color + "\n}\n.ly-bg-color {\n  background: " + this.primary.color + "\n}\n.vibrant-canvas {\n  display: none;\n}\n";
        var /** @type {?} */ __ = document.querySelector('body').appendChild(style);
        this._style = __;
    };
    /**
     * @param {?} key
     * @param {?} color
     * @return {?}
     */
    LyPalette.prototype.getPalette = function (key, color) {
        this.lyTheme.AlyleUI.palette[key] = color;
        return this.lyTheme.AlyleUI.palette;
    };
    /**
     * @param {?} data
     * @param {?=} returnVal
     * @return {?}
     */
    LyPalette.prototype.setPrimary = function (data, returnVal) {
        if (returnVal === void 0) { returnVal = false; }
        var /** @type {?} */ color = this.findColor(data);
        this.lyTheme.primary.next(color);
        this.lyTheme.palette.next(this.getPalette('primary', color));
        this._primary = color;
        // this.updateTheme();
        if (returnVal) {
            return color;
        }
    };
    ;
    /**
     * @param {?} data
     * @return {?}
     */
    LyPalette.prototype.findColor = function (data) {
        return LyPalette.colors.find(function (_) { return _.name === data; });
    };
    /**
     * @param {?} color
     * @param {?=} returnVal
     * @return {?}
     */
    LyPalette.prototype.setAccent = function (color, returnVal) {
        if (returnVal === void 0) { returnVal = false; }
        var /** @type {?} */ _color = this.findColor(color);
        this._accent = _color;
        // this.updateTheme();
        this.accent.next(_color);
        if (returnVal) {
            return _color;
        }
    };
    ;
    /**
     * @param {?} color
     * @param {?=} returnVal
     * @return {?}
     */
    LyPalette.prototype.setOther = function (color, returnVal) {
        if (returnVal === void 0) { returnVal = false; }
        var /** @type {?} */ _color = this.findColor(color);
        this._other = _color;
        // this.updateTheme();
        this.other.next(_color);
        if (returnVal) {
            return _color;
        }
    };
    ;
    return LyPalette;
}());
export { LyPalette };
LyPalette.colors = [
    {
        name: 'pink',
        color: '#ff4b73',
        text: 'rgba(0, 0, 0, 0.5)',
    },
    {
        name: 'pinkLight',
        color: '#f50057',
        text: 'rgba(0, 0, 0, 0.65)',
    },
    {
        name: 'cyan',
        color: '#00bcd4',
        text: 'rgba(0, 0, 0, 0.66)',
    },
    {
        name: 'red',
        // 'background': '#f44336',
        color: '#FF5252',
        text: 'rgba(0, 0, 0, 0.66)',
    },
    {
        name: 'amber',
        color: '#ffc107',
        text: 'rgba(0, 0, 0, 0.66)',
    },
    {
        name: 'teal',
        color: '#009688',
        text: 'rgba(0, 0, 0, 0.66)',
    },
    {
        name: 'purple',
        color: '#ce30c9',
        text: 'rgba(0, 0, 0, 0.66)',
    },
    {
        name: 'lightBlue',
        color: '#03A9F4',
        text: 'rgba(0, 0, 0, 0.5)',
    },
    {
        name: 'blue',
        color: '#2196F3',
        text: 'rgba(0, 0, 0, 0.5)',
    },
    {
        name: 'deepOrange',
        color: '#FF5722',
        text: 'rgba(0, 0, 0, 0.66)',
    },
];
LyPalette.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LyPalette.ctorParameters = function () { return [
    { type: LyTheme, },
]; };
function LyPalette_tsickle_Closure_declarations() {
    /** @type {?} */
    LyPalette.colors;
    /** @type {?} */
    LyPalette.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyPalette.ctorParameters;
    /** @type {?} */
    LyPalette.prototype._style;
    /** @type {?} */
    LyPalette.prototype._primary;
    /** @type {?} */
    LyPalette.prototype._accent;
    /** @type {?} */
    LyPalette.prototype._other;
    /** @type {?} */
    LyPalette.prototype.palette;
    /** @type {?} */
    LyPalette.prototype.themeApp;
    /** @type {?} */
    LyPalette.prototype.text;
    /** @type {?} */
    LyPalette.prototype.lyTheme;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/core/palette.js
// module id = 156
// module chunks = 31